import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms'
import { Validators } from '@angular/forms'

// Pattern: allows all Unicode letters, marks, apostrophes, dashes, and periods (no emojis)
export const NameValidator = Validators.pattern(/^[\p{L}\p{M}\p{Po}\p{Pd} ]*$/u)

/** This pattern accepts all the phonenumbers that are currently in the database. */
export const PhoneValidator = Validators.pattern(/^([0-9 -+():M/.]{0,44})$/)

/**
 * Domain name validation pattern that allows:
 *
 * - Example.com, sub.example.com, sub.sub.example.com This is not a water tight
 *   and spec compliant validation, but good enough for our purposes. Keep in
 *   line with the regex at the server side.
 */
export const DomainValidator = Validators.pattern(
  /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/i
)

/**
 * Basic validation that should handle most vat numbers in the world. Does not
 * do full validation, as this requires a backend api call
 *
 * @param control
 * @returns
 */
export const VatNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const vatPattern = /^[A-Z]{0,2}[\dA-Z]{8,12}$/i

  // Remove all spaces from the VAT number
  const cleanedVatNumber = (control.value || '').replace(/\s+/g, '')

  return vatPattern.test(cleanedVatNumber) ? null : { invalidVatNumber: true }
}

export function OptionalValidator(validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value === null || control.value === '') {
      return null
    }
    return validator(control)
  }
}
